var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('notifyWrapper'),_c('div',{staticClass:"header--error d-flex align-center px-5",staticStyle:{"width":"100%"}},[_c('img',{staticStyle:{"max-width":"150px","padding":"10px"},attrs:{"src":require("@/assets/it-logo.svg")}})]),_c('v-main',{staticClass:"layout--error"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }